export default __webpack_public_path__ + "static/je-4e2fc01b551946f8cbb9f9b23acde4ea.svg";